import React from 'react';
import { Modal, Button } from 'react-bootstrap';

export const ConfirmDeleteDialog = (props) => {
    const { visible, onConfirm, onCancel, message } = props;
    return (
        <Modal show={visible} onHide={onCancel}>
            <Modal.Header closeButton>
                <Modal.Title>Confirmation</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>{message}</p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onCancel}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={onConfirm}>
                    Confirm
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
